import React, { useState, useEffect } from "react";
import {
  Button,
  TableRow,
  Table,
  TableHead,
  TableBody,
  TableCell, TableContainer,
  Paper
} from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import { Grid } from "@material-ui/core";
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import StudentService from "./Locality/Service/studentService";
import SoundMasterService from "./Locality/Service/soundMasterService";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#0f3b62ad",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
  tableOverflow: {
    overflowX: "auto",
  },
}));

export default function Sound() {
  const classes = useStyles();
  const [studentList, setStudentList] = useState([]);
  const [sounds, setSounds] = useState([]);
  const [tableHeaders, setTableHeaders] = useState(["Student Name"]);
  const [pg, setPg] = useState(0);
  const [rpg, setRpg] = useState(5);
  // const tableHeaders = [
  //   "Student Name",
  //   "SPL",
  //   "a",
  //   "i",
  //   "o",
  //   "u",
  //   "e",
  //   "m",
  //   "n",
  //   "r",
  //   "s",
  //   "l",
  //   "f",
  //   "h",
  //   "v",
  //   "y",
  //   "z",
  //   "w",
  //   "k",
  //   "t",
  //   "p",
  //   "b",
  //   "d",
  //   "g",
  //   "j",
  //   "c",
  //   "x",
  //   "q",
  // ];

  // const sounds = [
  //   "SPL",
  //   "a",
  //   "i",
  //   "o",
  //   "u",
  //   "e",
  //   "m",
  //   "n",
  //   "r",
  //   "s",
  //   "l",
  //   "f",
  //   "h",
  //   "v",
  //   "y",
  //   "z",
  //   "w",
  //   "k",
  //   "t",
  //   "p",
  //   "b",
  //   "d",
  //   "g",
  //   "j",
  //   "c",
  //   "x",
  //   "q",
  // ];


  const handleChangePage = (event, newPage) => {
    setPg(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRpg(parseInt(event.target.value, 10));
    setPg(0);
  };

  // Fetch sounds list from API and combine with existing student sounds
  const getSoundsList = () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail") || "{}");
    const body = {
      schooleId: userDetails.schooleId || "",
      classId: userDetails.classId || "",
    };

    SoundMasterService.findSoundMasterList(body)
      .then((res) => {
        // Extract unique sound names from SoundMaster (all records, not filtered by sound: true)
        const masterSoundNames = [...new Set(
          res
            .map(item => item.name)
            .filter(name => name) // Remove empty/null names
        )];
        
        // Get existing sounds from students
        const getExistingStudentSounds = () => {
          const userDetails = JSON.parse(localStorage.getItem("userDetail") || "{}");
          const getSpeList = { classId: userDetails.classId };
          
          return StudentService.getAllStudentById(userDetails.schooleId, getSpeList)
            .then((studentRes) => {
              // Collect all sound keys from all students
              const allStudentSounds = new Set();
              studentRes.forEach((student) => {
                if (student.sounds && typeof student.sounds === 'object') {
                  Object.keys(student.sounds).forEach(key => {
                    if (key) allStudentSounds.add(key);
                  });
                }
              });
              return Array.from(allStudentSounds);
            })
            .catch((err) => {
              console.error("Error fetching existing student sounds:", err);
              return [];
            });
        };

        // Combine master sounds with existing student sounds
        getExistingStudentSounds().then((existingSounds) => {
          // Merge both arrays and remove duplicates
          const combinedSounds = [...new Set([...masterSoundNames, ...existingSounds])];
          
          // Sort sounds alphabetically
          combinedSounds.sort();
          
          setSounds(combinedSounds);
          // Update table headers dynamically
          setTableHeaders(["Student Name", ...combinedSounds]);
        });
      })
      .catch((err) => {
        console.error("Error fetching sounds list:", err);
        // Fallback: try to get existing sounds from students
        const userDetails = JSON.parse(localStorage.getItem("userDetail") || "{}");
        const getSpeList = { classId: userDetails.classId };
        StudentService.getAllStudentById(userDetails.schooleId, getSpeList)
          .then((studentRes) => {
            const allStudentSounds = new Set();
            studentRes.forEach((student) => {
              if (student.sounds && typeof student.sounds === 'object') {
                Object.keys(student.sounds).forEach(key => {
                  if (key) allStudentSounds.add(key);
                });
              }
            });
            const existingSounds = Array.from(allStudentSounds).sort();
            setSounds(existingSounds);
            setTableHeaders(["Student Name", ...existingSounds]);
          })
          .catch((studentErr) => {
            setSounds([]);
            setTableHeaders(["Student Name"]);
          });
      });
  };

  const getStudentList = () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail") || "{}");
    const getSpeList = { classId: userDetails.classId };

    StudentService.getAllStudentById(userDetails.schooleId, getSpeList)
      .then((res) => {
        const studentDetails = res.map((student) => {
          // Ensure each student has a sounds object; initialize if missing
          const soundsObj = student.sounds || {};
          sounds.forEach((sound) => {
            if (!(sound in soundsObj)) {
              soundsObj[sound] = false; // Initialize sound as unchecked
            }
          });
          return {
            _id: student._id,
            studentName: `${student.firstName} ${student.lastName}`,
            sounds: soundsObj,
          };
        });
        setStudentList(studentDetails);
      })
      .catch((err) => {
        console.error("Error fetching student list:", err);
      });
  };

  const handleCheck = (student, soundKey) => {
    // Get the current checked state
    const currentValue = student.sounds[soundKey] || false;
    const newValue = !currentValue;
    
    // Ensure all sounds from master list are included in the update
    const soundsObj = { ...student.sounds };
    // Initialize all sounds from master list if not present
    sounds.forEach((sound) => {
      if (!(sound in soundsObj)) {
        soundsObj[sound] = false;
      }
    });
    // Update the specific sound that was checked/unchecked
    soundsObj[soundKey] = newValue;

    // Update the student's sound locally
    const updatedStudent = {
      ...student,
      sounds: soundsObj,
    };

    // Update the student list state immediately for better UX
    const updatedList = studentList.map((s) =>
      s._id === student._id ? updatedStudent : s
    );
    setStudentList(updatedList);

    // Call API to update the student
    StudentService.upadeStudent(updatedStudent)
      .then((res) => {
        // Don't refetch immediately - keep the local state
        // The state is already updated above, so no need to refetch
        console.log("Student sound updated successfully");
      })
      .catch((err) => {
        console.error(err.response?.data?.message || "Error updating student");
        // On error, revert the local state by refetching
        getStudentList();
      });
  };

  useEffect(() => {
    // Fetch sounds list first, then fetch students
    getSoundsList();
  }, []);

  useEffect(() => {
    // Fetch students when sounds are loaded
    if (sounds.length > 0) {
      getStudentList();
    }
    return () => {
      setStudentList([]);
    };
  }, [sounds]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={10}>
          <PageTitle title="Sounds" />
        </Grid>
      </Grid>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget
            title=""
            upperTitle
            noBodyPadding
            bodyClass={classes.tableOverflow}
          >
            {/* <Table className="mb-0">
              <TableHead>
                <TableRow>
                  {tableHeaders.map((key) => (
                    <StyledTableCell key={key}>{key}</StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {studentList
                  .slice(pg * rpg, pg * rpg + rpg)
                  .map((student) => (
                    <TableRow key={student._id}>
                      <TableCell className="pl-3 fw-normal">
                        {student.studentName}
                      </TableCell>
                      {sounds.map((soundKey) => (
                        <TableCell key={soundKey} className="pl-3 fw-normal">
                          <input
                            type="checkbox"
                            checked={student.sounds[soundKey] || false}
                            style={{ height: "15px", width: "15px" }}
                            onChange={() => handleCheck(student, soundKey)}
                          />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
              </TableBody>
            </Table> */}
            <TableContainer component={Paper} style={{ maxHeight: 500 }}>
  <Table stickyHeader className="mb-0">
    <TableHead>
      <TableRow>
        {tableHeaders.map((key) => (
          <StyledTableCell key={key}>{key}</StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
    <TableBody>
      {studentList
        .slice(pg * rpg, pg * rpg + rpg)
        .map((student) => (
          <TableRow key={student._id}>
            <TableCell className="pl-3 fw-normal">
              {student.studentName}
            </TableCell>
            {sounds.map((soundKey) => (
              <TableCell key={soundKey} className="pl-3 fw-normal">
                <input
                  type="checkbox"
                  checked={student.sounds[soundKey] || false}
                  style={{ height: "15px", width: "15px" }}
                  onChange={() => handleCheck(student, soundKey)}
                />
              </TableCell>
            ))}
          </TableRow>
        ))}
    </TableBody>
  </Table>
</TableContainer>

            <TablePagination
              component="div"
              rowsPerPageOptions={[5, 50, 100, 500, 1000]}
              count={studentList.length}
              page={pg}
              onPageChange={handleChangePage}
              rowsPerPage={rpg}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Widget>
        </Grid>
      </Grid>
    </>
  );
}